import { useEffect } from 'react'
import { useEnv } from '../../context'
import { onOnline } from '../../platform/network'

/**
 * Отправка очереди Штаба на уровне приложения (PWA): при открытии, при
 * появлении сети и при возврате в приложение (вкладка снова видна). Сама
 * отправка склеивает повторные поводы и идёт одна на устройство.
 */
export function useHubQueueRunner(): void {
  const { hubQueue, platform } = useEnv()
  useEffect(() => {
    if (platform.hubMode !== 'chat') return
    void hubQueue.kick()
    const offOnline = onOnline(() => void hubQueue.kick())
    const onVisible = () => {
      if (document.visibilityState === 'visible') void hubQueue.kick()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      offOnline()
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [hubQueue, platform])
}
